import { gql } from '@apollo/client';

/** mutation to create user comment for FR2052A rule */
export const CREATE_FRY9C_USER_COMMENT = gql`
mutation createFRY9CUserComment($input: CreateFRY9CUserCommentInput) {
	createFRY9CUserComment(input: $input)
}`;

/** mutation to update user comment for FR2052A rule */
export const UPDATE_FRY9C_USER_COMMENT = gql`
mutation updateFRY9CUserComment($input: UpdateFRY9CUserCommentInput) {
	updateFRY9CUserComment(input: $input)
}`;

export const DELETE_FRY9C_USER_COMMENT = gql`
mutation deleteFRY9CUserComment($input: DeleteFRY9CUserCommentInput) {
	deleteFRY9CUserComment(input: $input)
}`;

export const CREATE_CLASSIFY_AUDIT_LOGS_FOR_FRY9C = gql`
mutation createClassifyAuditLogForFRY9C($input: ClassifyFRY9CInput) {
	createClassifyAuditLogForFRY9C(input: $input)
}`;
